// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
// MODFIED DATE:19-09-2025
//Last ADD :CODE REVIEW CHANGES AND ADD VERSION
import { all, call, put, takeLatest } from 'redux-saga/effects';
import productTypeActionTypes from './product-type.types';
import {
	addProductTypeDetailsFailure,
	addProductTypeDetailsResponseChanged,
	addProductTypeDetailsSuccess,
	deleteProductTypeDetailsFailure,
	deleteProductTypeDetailsResponseChanged,
	deleteProductTypeDetailsSuccess,
	fetchProductTypeDetailsFailure,
	fetchProductTypeDetailsResponseChanged,
	fetchProductTypeDetailsSuccess,
	getProductTypeListFailure,
	getProductTypeListResponseChanged,
	getProductTypeListSuccess,
	updateProductTypeDetailsFailure,
	updateProductTypeDetailsResponseChanged,
	updateProductTypeDetailsSuccess,
} from './product-type.action';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	productTypeDetailsAdd,
	productTypeDetailsDelete,
	productTypeDetailsFetch,
	productTypeDetailsUpdate,
	productTypeListGet,
} from './product-type.services';

/** *********************  START ADD PRODUCT TYPE DETAILS  ******************** */
export function* createProductType({ payload }: any) {
	const {
		productTypeName,
		companyID,
		userID,
		userName,
		userAccessBranchID,
		databaseName,
		infogCompanyID,
	} = payload;
	try {
		const key = 'AddProductTypeDetailKey';
		const jsonData = {
			ProductTypeName: productTypeName,
			CompanyID: companyID,
			CreatedBy: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			DatabaseName: databaseName,
			InfogID: infogCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(productTypeDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addProductTypeDetailsFailure(responseData.data));
		} else {
			yield put(addProductTypeDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addProductTypeDetailsFailure(error));
	}
}

export function* resetAddProductTypeResponse() {
	yield put(addProductTypeDetailsResponseChanged());
}

export function* onCreateProductTypeDetails() {
	yield takeLatest(productTypeActionTypes.ADD_PRODUCT_TYPE_DETAILS_START, createProductType);
}

export function* onCreateProductTypeResponseReset() {
	yield takeLatest(
		productTypeActionTypes.ADD_PRODUCT_TYPE_DETAILS_RESPONSE_RESET,
		resetAddProductTypeResponse,
	);
}
/** *********************  END ADD PRODUCT TYPE DETAILS ******************** */

export function* productTypeUpdate({ payload }: any) {
	try {
		const key = 'UpdateProductTypeDetailsKey';
		const {
			productTypeID,
			productTypeName,
			companyID,
			userID,
			userName,
			userAccessBranchID,
			databaseName,
			infogCompanyID,
		} = payload;
		const jsonData = {
			ProductTypeID: productTypeID,
			ProductTypeName: productTypeName,
			CompanyID: companyID,
			CreatedBy: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			DatabaseName: databaseName,
			InfogID: infogCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(productTypeDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateProductTypeDetailsFailure(responseData.data));
		} else {
			yield put(updateProductTypeDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateProductTypeDetailsFailure(error));
	}
}

export function* resetUpdateProductTypeDetailsResponse() {
	yield put(updateProductTypeDetailsResponseChanged());
}

export function* onUpdateProductTypeDetails() {
	yield takeLatest(productTypeActionTypes.UPDATE_PRODUCT_TYPE_DETAILS_START, productTypeUpdate);
}

export function* onUpdateProductTypeResponseReset() {
	yield takeLatest(
		productTypeActionTypes.UPDATE_PRODUCT_TYPE_DETAILS_RESPONSE_RESET,
		resetUpdateProductTypeDetailsResponse,
	);
}
/** *********************  END UPDATE PRODUCT TYPE DETAILS ******************** */

/** *********************  START GET PRODUCT TYPE LIST  ******************** */
export function* productTypeDetailsListGet({ payload }: any) {
	try {
		const key = 'GetProductTypeListKey';
		const { companyID, inputSearch, limit, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			InputSearch: inputSearch,
			Limit: limit,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(productTypeListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getProductTypeListFailure(responseData.data));
		} else {
			yield put(getProductTypeListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getProductTypeListFailure(error));
	}
}

export function* resetGetProductTypeListResponse() {
	yield put(getProductTypeListResponseChanged());
}

export function* onGetProductTypeListDetails() {
	yield takeLatest(productTypeActionTypes.GET_PRODUCT_TYPE_LIST_START, productTypeDetailsListGet);
}

export function* onGetProductTypeListResponseReset() {
	yield takeLatest(
		productTypeActionTypes.GET_PRODUCT_TYPE_LIST_RESPONSE_RESET,
		resetGetProductTypeListResponse,
	);
}
/** *********************  END GET PRODUCT TYPE LIST ******************** */

/** *********************  START FETCH PRODUCT TYPE DETAILS  ******************** */
export function* fetchProductTypeData({ payload }: any) {
	try {
		const key = 'FetchProductTypeDetailsKey';
		const { companyID, productTypeID, databaseName } = payload;
		const jsonData = {
			CompanyID: companyID,
			ProductTypeID: productTypeID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(productTypeDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchProductTypeDetailsFailure(responseData.data));
		} else {
			yield put(fetchProductTypeDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchProductTypeDetailsFailure(error));
	}
}

export function* resetFetchProductTypeDetailsResponse() {
	yield put(fetchProductTypeDetailsResponseChanged());
}

export function* onFetchProductTypeDetails() {
	yield takeLatest(productTypeActionTypes.FETCH_PRODUCT_TYPE_DETAILS_START, fetchProductTypeData);
}

export function* onFetchProductTypeResponseReset() {
	yield takeLatest(
		productTypeActionTypes.FETCH_PRODUCT_TYPE_DETAILS_RESPONSE_RESET,
		resetFetchProductTypeDetailsResponse,
	);
}
/** *********************  END FETCH PRODUCT TYPE DETAILS ******************** */

/** *********************  START DELETE PRODUCT TYPE DETAILS  ******************** */
export function* productTypeDelete({ payload }: any) {
	try {
		const key = 'DeleteProductTypeDetailsKey';
		const {
			companyID,
			productTypeID,
			productTypeName,
			databaseName,
			userID,
			userAccessBranchID,
			userName,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			ProductTypeID: productTypeID,
			ProductTypeName: productTypeName,
			DatabaseName: databaseName,
			DeletedBy: userID,
			UserAccessBranchID: userAccessBranchID,
			UserName: userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(productTypeDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteProductTypeDetailsFailure(responseData.data));
		} else {
			yield put(deleteProductTypeDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteProductTypeDetailsFailure(error));
	}
}

export function* resetDeleteProductTypeDetailsResponse() {
	yield put(deleteProductTypeDetailsResponseChanged());
}

export function* onDeleteProductTypeDetail() {
	yield takeLatest(productTypeActionTypes.DELETE_PRODUCT_TYPE_DETAILS_START, productTypeDelete);
}

export function* onDeleteProductTypeResponseReset() {
	yield takeLatest(
		productTypeActionTypes.DELETE_PRODUCT_TYPE_DETAILS_RESPONSE_RESET,
		resetDeleteProductTypeDetailsResponse,
	);
}
/** *********************  END DELETE PRODUCT TYPE DETAILS ******************** */

export function* productTypeMasterSaga() {
	yield all([
		call(onCreateProductTypeDetails),
		call(onCreateProductTypeResponseReset),
		call(onUpdateProductTypeDetails),
		call(onUpdateProductTypeResponseReset),
		call(onGetProductTypeListDetails),
		call(onGetProductTypeListResponseReset),
		call(onFetchProductTypeDetails),
		call(onFetchProductTypeResponseReset),
		call(onDeleteProductTypeDetail),
		call(onDeleteProductTypeResponseReset),
	]);
}
